module.exports = __webpack_public_path__ + "img/comment.9f26d0d8.jpg";